<template>
    <div>
        <edit-trainees-content-modal
            v-model="show_trainee_dialog"
            :modelProp="contents.trainee"
            :constants="constants"
        />
        <h4 class="tw-text-secondary mt-3 mb-3">Trainee</h4>
        <div class="tw-mb-2">
            {{ $root.sanitizeAndTruncateHTML(contents.trainee.body, 200) }}
        </div>
        <v-btn @click="editTrainee" class="main-btn">Edit Trainee</v-btn>
    </div>
</template>

<script>
import InternalTableSection from "@/Generic/InternalTableSection";
import EditTraineesContentModal from "@/Modals/EditTraineesContentModal";

export default {
    name: "WebsiteContentTrainee",
    components: {
        InternalTableSection,
        EditTraineesContentModal,
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'contents': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'committees': {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },

    },
    data() {
        return {
            show_content1_dialog: false,
            show_content2_dialog: false,
            modelObject: {},
            saveLoading: false,
            show_trainee_dialog: false,
            traineeSelected: this.trainee,
        }
    },
    mounted() {
        //
    },
    computed: {

    },
    methods: {
        editTrainee() {
            this.traineeSelected = null
            this.show_trainee_dialog = true
        },
    }
}
</script>
<style scoped>
.description {
    font-size: 0.9em;
}
</style>
